<template>
  <a-modal
    :title="title"
    :width="600"
    :visible="isShow"
    :confirm-loading="btnloading"
    @ok="handleSubmit"
    @cancel="handleCancel"
  >
    <a-form-model ref="formDom" :model="form" :rules="rules" :label-col="{ span: 5 }" :wrapper-col="{ span: 15 }">
      <a-form-model-item label="平台" prop="project">
        <a-select
          v-model="businessLines"
          allowClear
          show-search
          option-filter-prop="children"
          placeholder="选择平台"
          :disabled="isEdit"
          style="width: 100%"
          @change="handleChange"
        >
          <a-select-option v-for="item in platformList" :key="item.id" :value="`${item.project}-${item.type}-${item.org}`">{{ item.org }}</a-select-option>
        </a-select>
      </a-form-model-item>
      <a-form-model-item label="平台分类" prop="platform_class">
        <a-select v-model="form.platform_class" allowClear show-search option-filter-prop="children" placeholder="选择平台分类" :disabled="isEdit" style="width: 100%">
          <a-select-option v-for="item in PLATFORM_CLASS" :key="item.key" :value="item.key">{{ item.value }}</a-select-option>
        </a-select>
      </a-form-model-item>
      <a-form-model-item label="域名" prop="domain">
        <a-input-search
          v-model="form.domain"
          :maxLength="100"
          placeholder="请输入域名"
          enter-button="校验"
          :disabled="isEdit"
          size="default"
          @search="onSearch"
        />
      </a-form-model-item>
      <a-form-model-item label="名称" prop="platform_name">
        <a-input v-model="form.platform_name" allowClear placeholder="请输入名称" />
      </a-form-model-item>
    </a-form-model>
  </a-modal>
</template>
<script>
import { reactive, toRefs, getCurrentInstance, onMounted, watch } from '@vue/composition-api'
import { form, rules } from '../business/filialeList'
import dialog from '@/composables/dialog'
import compuedFun from '../computed/'
import api from '@/api/'

const title = {
  Add: '新增站点',
  Edit: '编辑站点',
}

export default {
  mixins: [dialog],
  props: {
    platformList: {
      type: [Object, Array],
      default() {
        return {}
      },
    },
    isEdit: {
      type: Boolean,
      default: false,
    },
    params: {
      type: Object,
      default: null,
    }
  },
  setup(props, { root }) {
    const _this = getCurrentInstance()
    const state = reactive({
      rules,
      title: title.Add,
      btnloading: false,
      businessLines: undefined,
      form: { ...form },
      isValid: false
    })
    watch(
      () => _this.params,
      async () => {
        const oldForm = JSON.parse(JSON.stringify(_this.params))
        state.businessLines = oldForm.project_name
        state.form = {
          project: oldForm.project,
          project_name: oldForm.project_name,
          type: oldForm.type,
          type_name: oldForm.type_name,
          platform_class: Number(oldForm.platform_class),
          domain: oldForm.domain,
          platform_name: oldForm.platform_name
        }
      }
    )
    onMounted(async () => {
      state.title = _this.isEdit ? title.Edit : title.Add
    })
    const methods = {
      // 平台下拉选择
      handleChange() {
        state.form.project = state.businessLines.split('-')[0]
        state.form.type = state.businessLines.split('-')[1]
        if (Number(state.form.type) === 0) {
          state.form.project_name = state.businessLines.split('-')[2]
          state.form.type_name = ''
        } else {
          state.form.project_name = state.businessLines.split('-')[2].split(' > ')[0]
          state.form.type_name = state.businessLines.split('-')[2].split(' > ')[1]
        }
      },
      handleSubmit() {
        state.btnloading = true
        _this.$refs.formDom.validate(async (valid) => {
          let res = null
          const data = _this.isEdit ? { ...state.form, id: _this.params.id } : { ...state.form }
          if (valid) {
            if (!state.isValid && !_this.isEdit) {
              _this.$message.warning('域名校验成功再提交~')
              state.btnloading = false
              return
            }
            if (_this.isEdit) {
              res = await api.cacheSiteUpdate(data)
            } else {
              res = await api.cacheSiteCreate(data)
            }
            if (_this.$validate(res)) {
              _this.$message.success(_this.isEdit ? '编辑成功~' : '添加成功~')
              _this.isShow = false
              state.btnloading = false
              _this.$emit('handleOver')
            } else {
              state.btnloading = false
            }
          } else {
            _this.$message.warning('请检查信息是否填写完成')
            state.btnloading = false
          }
        })
      },
      handleCancel() {
        _this.$refs.formDom.resetFields()
        _this.isShow = false
      },
      async onSearch(str) {
        if (str) {
          const res = await api.cacheSiteCheck({
            domain: str
          })
          if (res.code === '000000') {
            state.isValid = true
            _this.$message.success('域名校验成功~')
          } else {
            state.isValid = false
          }
        } else {
          _this.$message.warning('请输入域名再校验~')
        }
      }
    }
    return {
      ...toRefs(state),
      ...compuedFun(),
      ...methods
    }
  }
}
</script>
<style scoped lang="less">
/deep/.ant-form-item-label {
  width: 90px;
}
/deep/.ant-form-item-control-wrapper {
  width: 432px;
}
</style>
